import React, { useState } from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import sideImg from "../../assets/auth-side.png";
import api from "../../api/axios";

export default function AuthEmail() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onContinue = async () => {
    setError("");
    setSubmitting(true);

    try {
      const res = await api.post("/auth/check-email", { email });
      const exists = !!res.data?.exists;

      if (exists) navigate(`/auth/login?email=${encodeURIComponent(email)}`);
      else navigate(`/auth/signup?email=${encodeURIComponent(email)}`);
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout sideImage={sideImg}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <IconButton onClick={() => navigate("/auth")} sx={{ ml: -1 }} aria-label="Back">
          <ArrowBackIcon />
        </IconButton>

        <Typography variant="h6">Continue with email</Typography>
      </Box>

      <Typography sx={{ color: "text.secondary", mb: 3, maxWidth: 420 }}>
        We’ll check if you have an account, and help create one if you don’t.
      </Typography>

      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Email (personal or work)
      </Typography>

      <TextField
        fullWidth
        placeholder="e.g. user@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoComplete="email"
      />

      {error ? (
        <Typography sx={{ color: "error.main", mt: 1.5, fontSize: 13 }}>
          {error}
        </Typography>
      ) : null}

      <Button
        fullWidth
        variant="contained"
        disabled={submitting || !email}
        onClick={onContinue}
        sx={{ mt: 4, opacity: submitting ? 0.8 : 1 }}
      >
        {submitting ? "Continuing..." : "Continue"}
      </Button>
    </AuthLayout>
  );
}
